/* Ajax loaders */
import { htmlElem } from './globals';
const loadingClass = 'loading';

const setAjaxLoading = (elem) => {
    elem = elem || htmlElem;
    elem.classList.add(loadingClass);
};

const setAjaxComplete = (elem) => {
    elem = elem || htmlElem;
    elem.classList.remove(loadingClass)
};

export {
    setAjaxLoading,
    setAjaxComplete
}